<template>
  <div class="container">
    <div class="content">
      <div class="content-icon">
        <van-icon
          name="checked"
          v-if="payStatus"
          color="rgb(80,182,116)"
          size="100px"
        />
        <van-icon
          name="clear"
          v-if="!payStatus"
          color="rgb(255,97,99)"
          size="100px"
        />
      </div>
      <div class="content-text">
        {{ payStatus ? '支付成功' : '支付失败' }}
      </div>
      <div class="btn-box">
        <van-button round type="info" size="large" @click="goList">{{
          ifpage(pre)
        }}</van-button>
      </div>
      <div class="btn-box">
        <van-button round type="primary" size="large" @click="goIndex"
          >返回首页</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      payStatus: true,
      pre: ''
    }
  },
  created() {},
  mounted() {
    if (this.$route.query.status == 0) {
      this.payStatus = false
    } else {
      this.payStatus = true
    }
    this.pre = this.$route.query.preType || 0
  },
  methods: {
    ifpage(pre) {
      let text = ''
      switch (pre) {
        case 'pre':
          text = '查看处方单'
          break
        case 'acid':
          text = '查看核酸记录'
          break
        default:
          text = '查看挂号单'
          break
      }
      return text
    },
    goList() {
      let data = {}
      switch (this.pre) {
        case 'pre':
          if (this.$route.query.status == 0) data.active = 0
          else data.active = 1
          this.$router.push({
            name: 'list',
            query: data
          })
          break
        case 'acid':
          if (this.$route.query.status == 0) data.active = '2'
          else data.active = '1'
          this.$router.push({
            name: 'acidList',
            query: data
          })
          break
        default:
          if (this.$route.query.status == 0) data.active = 0
          else data.active = 1
          this.$router.push({
            name: 'payList',
            query: data
          })
          break
      }
    },
    goIndex() {
      this.$router.push('/index')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-items: center;
  .content {
    width: 100vw;
    height: 100vw;
    display: flex;
    align-items: center;
    justify-items: center;
    flex-direction: column;
    &-icon {
      width: 50vw;
      height: 50vw;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &-text {
      width: 50vw;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .btn-box {
      width: 100%;
      padding: 0 15px;
      padding-top: 15px;
    }
    .btn-box button {
      font-size: 18px;
      height: 48px;
    }
  }
}
</style>
